var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataList',{attrs:{"title":"Бонуси","resource":"bonuses","columns":_vm.columns,"get-items-fn":_vm.getBonuses,"search-label":'Пошук за назвою клієнта'}})}
var staticRenderFns = []

export { render, staticRenderFns }